
// carousel scroll prompt

$(document).ready(function(){
  $('.ProductList').scroll(function(){
	$(this).parents('.ProductListWrapper').children('.carousel_scroll_prompt').fadeOut(200);
  });
});



$(document).ready(function(){
  $( "#currency-popover-button" ).click(function(){
    $( "#header-currency-popover" ).attr('aria-hidden', function (i, attr) {
    return attr == 'true' ? 'false' : 'true'
});
});
});



/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* SV 08.15.19 */
(function() {
  function on$Ready() {
    return new Promise(function(resolve, reject) {
      var t = setInterval(function() {
        if (typeof jQuery !== 'undefined') {
          clearInterval(t);
          resolve();
        }
      });
    });
  }
  
  function submitFormAjax($form) {
    return new Promise(function(resolve, reject) {
      $.ajax({
        url : $form.attr('action'),
        type: $form.attr('method'),
        data : $form.serialize(),
        success: function(response) {
          resolve(response);
        },
        error: function(err) {
          reject(err);
        }
      })
    });
  }
  
  function refreshCart() {
    document.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        quantity: 1
      }
    }));    
  }
  
  on$Ready().then(function() {
    $(document).on('click', '.add-to-cart', function(e) {
      e.preventDefault();
      var $btn = $(e.currentTarget);
      var formid = $btn.data('form-id');
      var $form = $('#' + formid);
      $btn.prop('disabled', true).text('Adding...');
      
      submitFormAjax($form).then(function() {
        refreshCart();
        setTimeout(function() {
          $btn.prop('disabled', false).text('Add to cart');
        }, 500);
      });
    });
  });
})();


// slider 100% height on mobile

  function checkSliderHeight() {
    if ( $(window).width() < 640 ) {
      var height = $(window).height() - 106;
      $('.Slideshow--fullscreen').css('height', height + 'px');
    } else {
      $('.Slideshow--fullscreen').css('height', '470px');
    }
  }

  $(document).ready(checkSliderHeight);
  $(window).on('load', checkSliderHeight);
  $(window).resize(checkSliderHeight);

var announcementBREAKPOINT = 768;
var announcementSlideIndex = 0;
var announcementSlider = ".custom-grid-slider";
var windowWidth = $(window).width();

var announcementSliderConfig = {
    arrows: false,
    mobileFirst:true,
    infinite: true,
    dots: true,
    //autoplay: true,
    speed: 1500,
    //vertical: true,
    touchMove: true,
    responsive: [          
      {
        breakpoint: 767,
        settings: {
          infinite: true,
          slidesToShow: 1,
          arrows: true
        }
      }
    ]
};
if (windowWidth >= announcementBREAKPOINT) {

} else {
    $(announcementSlider).on("afterChange", function (event, slick, currentSlide1) {
        announcementSlideIndex = currentSlide1;
    }).slick(announcementSliderConfig);
}
var resizeTimeout;
$(window).resize(function() {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(function() {
        var windowWidth = $(window).width();
        if (windowWidth >= announcementBREAKPOINT) {
            //desktop
            if ($('.custom-grid-slider.slick-initialized').length > 0) {
                $(announcementSlider).slick("unslick");
            }	
        } else {
            // mobile
            if ($('.custom-grid-slider.slick-initialized').length == 0) {
                $(announcementSlider).slick(announcementSliderConfig);
            } else {
                $(announcementSlider).slick("unslick").slick(announcementSliderConfig);
                $(announcementSlider).slick('slickGoTo', announcementSlideIndex, true);
            }				
        }
    }, 300);
});